// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2Ws02","avatar":"style_avatar__2eM_S","menuIcon":"style_menuIcon__3RlmI"};